import { IDictionary, Locales } from '@bimser/core';

export const getMessages = (): IDictionary<IDictionary<string>> => Locales;
